import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  meetings: [],
  loading: false, // Added loading state
  error: null, // Added error state
};

const MeetingTicketSlice = createSlice({
  name: "meetingTicket",
  initialState,
  reducers: {
    setMeetings: (state, action) => {
      state.meetings = action.payload;
      state.error = null;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Export all actions including the new ones
export const {
  setMeetings,
  setLoading,
  setError,
} = MeetingTicketSlice.actions;

export default MeetingTicketSlice.reducer;
